module.exports = __webpack_public_path__ + "static/media/horario-de-trabajo 1.6c99993f.svg";